import { useNavigate } from 'react-router-dom'
import { Bell, LogIn, Menu } from 'lucide-react'
import { useAuth } from '@/hooks/useAuth'

const C = { teal: '#0F5C5C', terra: '#D9785B', border: '#E1E5E3', ink: '#202523', ink2: '#6D7471' }
const FH = "'Plus Jakarta Sans', sans-serif"
const FB = "'Inter', sans-serif"

interface Props {
  onMenuToggle?: () => void
}

export default function Topbar({ onMenuToggle }: Props) {
  const { user, profile } = useAuth()
  const navigate = useNavigate()

  return (
    <header className="topbar">
      {/* ── Hamburguesa (solo móvil) ── */}
      <button
        className="topbar-hamburger"
        onClick={onMenuToggle}
        style={{
          width: 38,
          height: 38,
          borderRadius: 11,
          border: `1px solid ${C.border}`,
          background: '#fff',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
        }}
      >
        <Menu size={20} color={C.ink2} />
      </button>

      {/* ── Logo ── */}
      <div
        style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', flexShrink: 0 }}
        onClick={() => navigate('/')}
      >
        <div
          style={{
            width: 30,
            height: 30,
            borderRadius: '50% 50% 50% 4px',
            background: C.teal,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <span style={{ color: '#fff', fontSize: 16, lineHeight: 1 }}>⚡</span>
        </div>
        {/* Nombre: visible en desktop, oculto en móvil pequeño */}
        <span
          className="topbar-brand-name"
          style={{
            fontFamily: FH,
            fontWeight: 800,
            fontSize: 22,
            color: C.teal,
            letterSpacing: '-0.02em',
          }}
        >
          Párchala
        </span>
      </div>

      {/* ── Acciones derecha ── */}
      <div
        style={{ display: 'flex', alignItems: 'center', gap: 8, marginLeft: 'auto', flexShrink: 0 }}
      >
        {user ? (
          <>
            {/* Campana */}
            <button
              onClick={() => navigate('/notifications')}
              style={{
                position: 'relative',
                width: 38,
                height: 38,
                borderRadius: 11,
                border: `1px solid ${C.border}`,
                background: '#fff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Bell size={18} />
              <span
                style={{
                  position: 'absolute',
                  top: -3,
                  right: -3,
                  width: 16,
                  height: 16,
                  borderRadius: 99,
                  background: C.terra,
                  color: '#fff',
                  fontSize: 9,
                  fontWeight: 700,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                3
              </span>
            </button>

            {/* Nombre del usuario — se muestra en todos los tamaños */}
            <button
              onClick={() => navigate('/profile')}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 9,
                padding: '7px 14px',
                borderRadius: 11,
                border: `1px solid ${C.border}`,
                background: '#fff',
                cursor: 'pointer',
                fontFamily: FB,
                fontWeight: 700,
                fontSize: 13.5,
                color: C.ink,
                whiteSpace: 'nowrap',
              }}
            >
              {profile?.username ?? user.email?.split('@')[0]}
            </button>
          </>
        ) : (
          <>
            <button
              onClick={() => navigate('/login')}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 7,
                padding: '10px 18px',
                borderRadius: 11,
                border: 'none',
                background: C.teal,
                color: '#fff',
                fontFamily: FB,
                fontWeight: 700,
                fontSize: 14,
              }}
            >
              <LogIn size={16} /> Ingresar
            </button>
          </>
        )}
      </div>
    </header>
  )
}
